import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { modalElement: String, onConnect: Boolean }
  }

  connect() {
    if (this.onConnectValue) {
      this.show()
    }
  }

  show() {
    new bootstrap.Modal(this.modalElementValue).show()
  }

  hide() {
    new bootstrap.Modal(this.modalElementValue).hide()
  }
}
